export function isPromise(maybePromise: any): maybePromise is Promise<any> {
  return (
    typeof maybePromise?.then === 'function' &&
    typeof maybePromise?.catch === 'function' &&
    typeof maybePromise?.finally === 'function'
  );
}
